<template>
  <svg
    :width="size"
    :height="size"
    viewBox="-2 -2 17 17"
    :fill="color"
    xmlns="http://www.w3.org/2000/svg"
    :style="{ color }"
  >
    <path
      width="20"
      height="50"
      d="M8.04883 6.30534C7.99805 6.35612 7.92188 6.38997 7.85417 6.38997C7.78646 6.38997 7.71029 6.35612 7.6595 6.30534L6.69466 5.34049C6.64388 5.28971 6.61003 5.21354 6.61003 5.14583C6.61003 5.07812 6.64388 5.00195 6.69466 4.95117L9.50456 2.14128L8.28581 0.922526C8.18424 0.820964 8.125 0.685547 8.125 0.541667C8.125 0.245443 8.37044 0 8.66667 0H12.4583C12.7546 0 13 0.245443 13 0.541667V4.33333C13 4.62956 12.7546 4.875 12.4583 4.875C12.3145 4.875 12.179 4.81576 12.0775 4.71419L10.8587 3.49544L8.04883 6.30534ZM4.875 12.4583C4.875 12.7546 4.62956 13 4.33333 13H0.541667C0.245443 13 0 12.7546 0 12.4583V8.66667C0 8.37044 0.245443 8.125 0.541667 8.125C0.685547 8.125 0.820964 8.18424 0.922526 8.28581L2.14128 9.50456L4.95117 6.69466C5.00195 6.64388 5.07812 6.61003 5.14583 6.61003C5.21354 6.61003 5.28971 6.64388 5.34049 6.69466L6.30534 7.6595C6.35612 7.71029 6.38997 7.78646 6.38997 7.85417C6.38997 7.92188 6.35612 7.99805 6.30534 8.04883L3.49544 10.8587L4.71419 12.0775C4.81576 12.179 4.875 12.3145 4.875 12.4583Z"
    />
  </svg>
</template>

<script>
import VueTypes from 'vue-types';

export default {
  name: 'ResizeSVG',
  props: {
    size: VueTypes.number.isRequired,
    color: VueTypes.string.isRequired,
  },
};
</script>

<style></style>
